import React from 'react'

import { Form, Col } from '_zari/core'

const AnioFormGroup = ({ value, onChange }) => {
  const aniosOptions = React.useMemo(() => {
    const anioActual = new Date().getFullYear()
    const limiteAnios = anioActual - 10

    const output = []

    for (let i = anioActual + 1; i >= limiteAnios; i--) {
      output.push(
        <option key={i} value={i}>
          {i}
        </option>
      )
    }

    return output
  }, [])

  return (
    <Form.Group>
      <Form.Label text='AÑO' htmlFor='select-anio' md={4} alignRightAt='md' />
      <Col md={8}>
        <Form.Select id='select-anio' name='select-anio' value={value} onChange={onChange}>
          <option value=''>--</option>
          {aniosOptions}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default React.memo(AnioFormGroup)
